var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,10c12.15,0 22,9.85 22,22c0,12.15 -9.85,22 -22,22c-12.15,0 -22,-9.85 -22,-22c0,-12.15 9.85,-22 22,-22zM39.589,40.968c0.404,-1.241 2.301,-13.615 2.534,-16.054c0.071,-0.738 -0.163,-1.229 -0.619,-1.449c-0.553,-0.265 -1.371,-0.133 -2.322,0.21c-1.303,0.47 -17.958,7.541 -18.92,7.951c-0.912,0.388 -1.775,0.81 -1.775,1.423c0,0.431 0.256,0.673 0.96,0.924c0.732,0.261 2.577,0.82 3.668,1.121c1.05,0.29 2.243,0.038 2.913,-0.378c0.709,-0.441 8.901,-5.921 9.488,-6.402c0.587,-0.48 1.056,0.135 0.576,0.616c-0.48,0.48 -6.102,5.937 -6.844,6.693c-0.901,0.917 -0.262,1.868 0.343,2.249c0.689,0.435 5.649,3.761 6.396,4.295c0.747,0.534 1.504,0.776 2.198,0.776c0.694,-0.001 1.059,-0.915 1.404,-1.975z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.70e0f1f5d2eebf1b48e2d25feb4606fb.svg";
export { ForwardRef as ReactComponent };